<template>
  <div>
    <div :style="getSectionStyle()">
      <span class="image-overlay"></span>
      <div class="full-screen-image-with-text-wrapper  wow fadeIn delay-1s">
        <div class="full-screen-image-with-text-con">
          <div class="full-screen-image-with-text-title-con">
            <h1>
              {{ productInfo.title[getIndex()] }}
            </h1>
          </div>
          <p>
            {{ productInfo.discription[getIndex()] }}
          </p>
          <div class="full-screen-image-with-text-scrollcon">
            <router-link
              to=""
              v-scroll-to="{
                el: '#productFeatures',
                duration: 800,
                easing: 'ease-in'
              }"
              style="color: white;"
              class="round"
            >
              {{ $t("features") }}
            </router-link>
          </div>
        </div>
      </div>
    </div>
    <div id="productFeatures" class="product-features-con">
      <ul>
        <li
          v-for="item in productInfo.features"
          :key="item.id"
          class="wow fadeInUp"
          style="color: white;"
        >
          {{ item[getIndex()] }}
        </li>
      </ul>
      <div>
        <v-carousel
          interval="4000"
          height="100%"
          style="width: 100%; margin: 100px auto 0px auto; color: white;"
          cycle
          hide-delimiter-background
          show-arrows-on-hover
        >
          <v-carousel-item
            v-for="(item, i) in productInfo.images"
            :key="i"
            style="transition: all 1s"
          >
            <div class="imageContainer">
              <img :src="getImage('products/', item)" class="img" />
            </div>
          </v-carousel-item>
        </v-carousel>
      </div>
      <div>
        <div class="product-image-list-container">
          <div
            v-for="(item, i) in productInfo.images"
            :key="i"
            :class="
              $i18n.locale === 'en'
                ? 'product-image-list-li-ltr'
                : 'product-image-list-li-rtl'
            "
            @click="handleClickImage(item)"
          >
            <img :src="getImage('products/', item)" style="width: 100%;" />
          </div>
        </div>

        <!-- modal -->
        <v-dialog v-model="dialog" width="75%">
          <img
            v-if="dialogImageName && dialogImageName.length > 0"
            :src="getImage('products/', dialogImageName)"
            style="width: 100%;"
          />
        </v-dialog>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";

export default {
  name: "ProductProfile",
  data() {
    return {
      dialog: false,
      dialogImageName: ""
    };
  },
  computed: mapGetters(["productInfo"]),
  created() {
    window.scrollTo(0, 0);
    this.getProductById(this.$route.params.id);
  },
  methods: {
    ...mapActions(["getProductById"]),
    getIndex() {
      if (this.$i18n.locale === "ku") return 0;
      else if (this.$i18n.locale === "ar") return 1;
      else return 2;
    },
    getImage(location, name) {
      return require("../../assets/" + location + name);
    },
    getSectionStyle() {
      if (this.productInfo && this.productInfo.profile) {
        let obj = {
          "background-image": `url(${this.getImage(
            "products/",
            this.productInfo.profile
          )})`,
          "background-position": "center",
          "background-repeat": "no-repeat",
          "background-attachment": "fixed",
          "-o-background-size": "cover",
          "-moz-background-size": "cover",
          "-webkit-background-size": "cover",
          "background-size": "cover"
        };

        if (this.isMobileSafari()) obj["background-attachment"] = "scroll";
        return obj;
      }
    },
    isMobileSafari() {
      return (
        navigator.userAgent.match(/(iPod|iPhone|iPad)/) &&
        navigator.userAgent.match(/AppleWebKit/)
      );
    },
    handleClickImage(imageName) {
      this.dialogImageName = imageName;
      this.dialog = !this.dialog;
    }
  }
};
</script>

<style lang="scss" scoped>
.product-features-con {
  padding: 200px 0px;
  width: 50%;
  margin: auto;
}
.product-features-con ul {
  list-style-type: square;
}
.product-features-con ul li:nth-child(even) {
  margin: 25px 0px;
}
@media (max-width: 768px) {
  .product-features-con {
    width: 85%;
    padding: 100px 0px;
  }
}

.imageContainer {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}
.img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.product-image-list-container {
  padding: 25px 0px;
  margin: 0px;
  display: flex;
  align-items: center;
  flex-wrap: wrap;
}
.product-image-list-container div {
  width: 200px;
  cursor: pointer;
}
@media (max-width: 768px) {
  .product-image-list-container div {
    width: 150px;
  }
}
@media (max-width: 625px) {
  .product-image-list-container div {
    width: 100px;
  }
}
@media (max-width: 375px) {
  .product-image-list-container div {
    width: 75px;
  }
}
.product-image-list-li-ltr {
  margin: 0px 20px 20px 0px;
}
.product-image-list-li-rtl {
  margin: 0px 0px 20px 20px;
}
</style>
